var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-226.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Up",
    transform: "translate(226.97)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4987",
    "data-name": "Path 4987",
    d: "M1,12.919A23.09,23.09,0,0,1,4.667,7.647c.9-.962,1.419-1.331,2.063-1.375,1.635-.112,2.276,1.59,3.438,1.375,1.66-.308,1.292-4.128,4.126-5.959A5.309,5.309,0,0,1,15.9,1",
    transform: "translate(5 6.081)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.42796c66fea2b9e103df3d22133cd84d.svg";
export { ForwardRef as ReactComponent };